<template>
  <div class="applicationStatesBox">
    <div class="main">
      <div v-if="status==1001">
        <img src="@/assets/img/app/reading.png" />
        <p class="title">审核中</p>
        <p class="desc">认证资料已提交，预计1-2个工作日内完成审核</p>
        <div class="button" @click="opation('reading')">查看认证信息</div>
      </div>
      <div v-if="status==1002">
        <img src="@/assets/img/app/success.png" />
        <p class="title">认证成功</p>
        <p class="desc">认证已审核通过，下载云端美育机构助手，登录设置机构主页（下载地址www.xxxxxxxxx.com）</p>
      </div>
      <div v-if="status==1003">
        <img src="@/assets/img/app/error.png" />
        <p class="title">认证失败</p>
        <p class="desc">
          认证失败，失败原因：
          <span>{{describe}}</span>
        </p>
        <div class="button" @click="opation('error')">重新认证</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  metaInfo() {
    return {
      title: "申请入驻",
    };
  },
  name: "applicationStates",
  data() {
    return {
      status: "", //1001审核中   1002成功    1003失败
      describe: "", //描述，针对认证失败描述
      businesstype: "", //业务类型:1000:国家机錧,1001艺术团体,1002培训机构
    };
  },

  mounted() {
    var info = this.info;
    if (!info) {
      this.getAuditStatus();
    } else {
      this.businesstype = info.businesstype;
      this.status = info.status;
      this.describe = info.describe;
    }
  }, 
  methods: {
    getAuditStatus() {
      this.$post(
        "gart-common-api/api/cmn/auditing/queryByAuditingStatus",
        {}
      ).then((res) => {
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            this.status = res.data.status;
            this.describe = res.data.describe;
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    opation(type) {
      switch (type) {
        case "reading":
          this.$router.push({
          path: "/app/application/publicCulture",
          query: {
            businesstype:this.businesstype,
            examineInfo:true,
          },
        });
          break;
        case "error":
          var obj = {
            this: this,
            loginStatus: true,
            url: "/app/application/applicationHome",
          };
          this.util.goto(obj);
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.applicationStatesBox {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 48px 16px 0;
  background: #ffffff;
  .main {
    flex: 1;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 48px;
        height: 48px;
      }
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #2d2d2d;
        margin: 16px 0 8px 0;
      }
      .desc {
        font-size: 14px;
        color: #86878a;
        text-align: center;
        span {
          color: #c94c4c;
        }
      }
      .button {
        background: #c94c4c;
        border-radius: 8px;
        color: #ffffff;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        margin-top: 32px;
        padding: 12px 40px;
      }
    }
  }
}
</style>